import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import apiUrl from '../../Config';
import { toast } from 'react-toastify';
import { Box, Button, CircularProgress, FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import HtmlEditor from '../../Common/HtmlEditor';


const AddEditTermsAndPrivacy = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const termsandprivacy = state?.termsprivacy;
    const [formData, setFormData] = useState({
        title: '',
        content: '',
        userType: '',
    });
    const [validateErrors, setValidateErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState('')

    useEffect(() => {
        if (termsandprivacy) {
            setFormData({
                title: termsandprivacy.title || '',
                content: termsandprivacy.content || '',
                userType: termsandprivacy.type || '',

            });
        }
    }, [termsandprivacy]);
     const titles = [
        { name: 'Terms and Conditions', value: 'termsandconditions' },
        { name: 'Privacy Policy', value: 'privacypolicy' },
    ];

    const userTypes = [
        { name: 'User', value: 'user' },
        { name: 'Technician', value: 'technician' },
        { name: 'Showroom', value: 'showroom' },
    ];
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setValidateErrors(prev => ({ ...prev, [name]: '' }));
    };
    const handleContentChange = (content) => {
        setFormData(prev => ({ ...prev,  content }));

        const stripped = content.replace(/<[^>]+>/g, '').trim();
        if (stripped) {
            setValidateErrors(prev => ({ ...prev, content: '' }));
        }
    };
    const validateForm = () => {
        const errors = {};

        if (!formData.title.trim()) {
            errors.title = 'Title is required';
        }

        const strippedContent = formData.content.replace(/<[^>]+>/g, '').trim();
        if (!strippedContent) {
            errors.content = 'Content is required';
        }

        const validUserTypes = ['user', 'technician', 'showroom'];
        if (!formData.userType || !validUserTypes.includes(formData.userType)) {
            errors.userType = 'Please select a valid user type';
        }

        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const errors = validateForm();
            if (Object.keys(errors).length > 0) {
                setValidateErrors(errors);
                return;
            }

            const payload = {
                title: formData.title.trim(),
                content: formData.content.trim(),
                type: formData.userType,
            };

            let response;

            if (termsandprivacy) {
                response = await axios.put(`${apiUrl}/termsprivacy/update/${termsandprivacy.id}`, payload);
            } else {
                response = await axios.post(`${apiUrl}/termsprivacy/create`, payload);
            }

            if (response.data.status === true) {
                navigate('/display-terms-privacies');
                toast.success(response.data.message);
            }

        } catch (error) {
            setErrors(error);
        } finally {
            setLoading(false);
        }
    };




    return (
        <>
            <Box p={{ sm: 2, xs: 2, md: 4, lg: 4 }}>
                <Typography variant="h4" mb={3}>
                    {termsandprivacy ? 'Edit Terms and Privacies' : 'Add Terms and Privacies'}
                </Typography>
                <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 500, border: '1px solid lightgrey', borderRadius: 1, p: 2 }}>

                    {/* Title Dropdown */}
                    <FormControl fullWidth size="small" sx={{ mb: 2 }} error={!!validateErrors.title}>
                        <InputLabel id="title-label">Title</InputLabel>
                        <Select
                            labelId="title-label"
                            name="title"
                            value={formData.title}
                            label="Title"
                            onChange={handleInputChange}
                        >
                            {titles.map((item) => (
                                <MenuItem key={item.value} value={item.value}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                        {validateErrors.title && <FormHelperText>{validateErrors.title}</FormHelperText>}
                    </FormControl>
                     <FormControl fullWidth size="small" sx={{ mb: 2 }} error={!!validateErrors.userType}>
                        <InputLabel id="user-type-label">User Type</InputLabel>
                        <Select
                            labelId="user-type-label"
                            name="userType"
                            value={formData.userType}
                            label="User Type"
                            onChange={handleInputChange}
                        >
                            {userTypes.map((item) => (
                                <MenuItem key={item.value} value={item.value}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                        {validateErrors.userType && <FormHelperText>{validateErrors.userType}</FormHelperText>}
                    </FormControl>

                    {/* Content (Rich Text Editor) */}
                    <Typography variant="subtitle1" mb={1}>Content</Typography>
                    <HtmlEditor
                        value={formData.content}
                        onChange={handleContentChange} // This updates formData.content
                    />
                    {validateErrors.content && (
                        <Typography variant="caption" color="error" sx={{ mb: 2, display: 'block' }}>
                            {validateErrors.content}
                        </Typography>
                    )}

                    {/* User Type Dropdown */}
                   

                    {/* Error Message */}
                    {errors && <Typography variant='body2' color='error'>{errors}</Typography>}

                    {/* Buttons */}
                    <Box mt={3} display="flex" justifyContent="right" gap={2}>
                        <Button variant="outlined" color="primary" onClick={() => navigate('/display-terms-privacies')}>
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            disabled={loading}
                            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                        >
                            {loading
                                ? (termsandprivacy ? 'Updating...' : 'Creating...')
                                : (termsandprivacy ? 'Update' : 'Create')}
                        </Button>
                    </Box>
                </Box>

            </Box>
        </>
    )
}

export default AddEditTermsAndPrivacy